import { Link, router } from "@inertiajs/react"
import { LogOut, Settings } from "lucide-react"

import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu"
import { UserInfo } from "@/components/user-info"
import { useMobileNavigation } from "@/hooks/use-mobile-navigation"
import {
  adminSettingsUsersPath,
  destroyAdminSessionPath,
  destroyUserSessionPath,
  settingsAccountPath,
} from "@/routes"
import type { User } from "@/types"

interface UserMenuContentProps {
  auth: {
    session: {
      id: string
    }
    user: User
    type: "user" | "admin"
  }
}

export function UserMenuContent({ auth }: UserMenuContentProps) {
  const { user, type } = auth
  const cleanup = useMobileNavigation()
  const logoutPath =
    type === "user" ? destroyUserSessionPath : destroyAdminSessionPath
  const settingsPath =
    type === "user" ? settingsAccountPath : adminSettingsUsersPath

  const handleLogout = () => {
    cleanup()
    router.flushAll()
  }

  return (
    <>
      <DropdownMenuLabel className="p-0 font-normal">
        <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
          <UserInfo user={user} showEmail={true} />
        </div>
      </DropdownMenuLabel>
      <DropdownMenuSeparator />
      <DropdownMenuGroup>
        <DropdownMenuItem asChild>
          <Link
            className="block w-full"
            href={settingsPath()}
            as="button"
            prefetch
            onClick={cleanup}
          >
            <Settings className="mr-2" />
            Settings
          </Link>
        </DropdownMenuItem>
      </DropdownMenuGroup>
      <DropdownMenuSeparator />
      <DropdownMenuItem asChild>
        <Link
          className="block w-full"
          method="delete"
          href={logoutPath()}
          as="button"
          onClick={handleLogout}
        >
          <LogOut className="mr-2" />
          Log out
        </Link>
      </DropdownMenuItem>
    </>
  )
}
